var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-box",staticStyle:{"z-index":"9999999","heigth":"100vh"}},[_c('div',{ref:"commonChart",style:(("height: " + _vm.height + "; width: 380px"))})])}
var staticRenderFns = []

export { render, staticRenderFns }